import React, { createContext, useContext } from 'react';

type FullScreenContextType = {
  toggleFullScreen: (forceExit?: boolean, forceEnter?: boolean) => void;
};

const FullScreenContext = createContext<FullScreenContextType | undefined>(undefined);

type FullScreenProviderProps = {
  toggleFullScreen: (forceExit?: boolean, forceEnter?: boolean) => void;
  children: React.ReactNode;
};

export const FullScreenProvider: React.FC<FullScreenProviderProps> = ({ toggleFullScreen, children }) => (
  <FullScreenContext.Provider value={{ toggleFullScreen }}>
    {children}
  </FullScreenContext.Provider>
);

export const useFullScreen = (): FullScreenContextType => {
  const context = useContext(FullScreenContext);
  if (!context) {
    throw new Error('useFullScreen must be used within a FullScreenProvider');
  }
  return context;
};
